const ITEMS = [
  "EV Charger Installation",
  "Panel Upgrades",
  "Emergency Electrical",
  "Commercial Wiring",
  "TSBC Licensed",
  "CleanBC Approved",
  "Vancouver & Lower Mainland",
];

export default function EmergencyMarquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee"
      className="border-y border-[#262626] bg-[#141414] overflow-hidden"
    >
      <div className="flex whitespace-nowrap em-marquee-track py-4">
        {row.map((it, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-6 px-6 text-xs md:text-sm tracking-[0.2em] uppercase text-white/70 font-semibold"
          >
            {it}
            <span className="w-1.5 h-1.5 bg-[#E60000] rotate-45" />
          </span>
        ))}
      </div>
    </div>
  );
}
